/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { TextInput, composeValidators, Checkbox } from '@blend/enterprise-components';

import { WrappedInput } from 'id-components/WrappedInput';
import { FinalFormInputConfig } from 'id-types/helpers';
import {
  emptyCheckboxValidator,
  emptyPasswordValidator,
  requiredEmailValidator,
  strengthAndMatchValidator,
} from 'id-utils/validators';
import { getPasswordInputConfig } from 'id-utils/inputs';

export const styles = StyleSheet.create({
  fieldWrapper: {
    ':not(:last-child)': {
      marginBottom: 16,
    },
  },
  footerComponentWrapper: {
    flex: '1',
  },
});

export const usernameInputConfig: FinalFormInputConfig<TextInput.Props, string> = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: { type: 'text' },
  inputComponent: TextInput,
  label: 'Email',
  labelSize: 'sm',
  name: 'username',
  validate: requiredEmailValidator,
};

export const passwordInputConfig = getPasswordInputConfig();

export const passwordInputConfigWithValidation = getPasswordInputConfig({
  name: 'newPassword',
  label: 'Create Password',
  validate: composeValidators(emptyPasswordValidator, strengthAndMatchValidator),
});

export const confirmPasswordInputConfig = getPasswordInputConfig({
  label: 'Confirm Password',
  name: 'confirmedPassword',
});

export const rememberMeInputConfig: FinalFormInputConfig<Omit<Checkbox.Props, 'checked'>, boolean> = {
  component: WrappedInput,
  containerStyles: [styles.footerComponentWrapper],
  customComponentProps: {},
  displayAdditionalMessagingInContainer: false,
  defaultValue: true,
  infoTooltip: 'If checked, on successful login you will not be asked to perform MFA for next 30 days',
  inputComponent: Checkbox,
  label: 'Remember my MFA for 30 days',
  labelPosition: 'right',
  labelSize: 'sm',
  name: 'rememberMe',
  type: 'checkbox',
};

export const confirmPhoneNumberInputConfig: FinalFormInputConfig<Omit<Checkbox.Props, 'checked'>, string> = {
  component: WrappedInput,
  containerStyles: [styles.footerComponentWrapper],
  customComponentProps: {},
  displayAdditionalMessagingInContainer: false,
  inputComponent: Checkbox,
  label: 'I confirm this is a mobile phone number',
  labelPosition: 'right',
  labelSize: 'sm',
  name: 'confirmPhoneNumber',
  type: 'checkbox',
  validate: composeValidators(emptyCheckboxValidator),
};
